module.exports = __webpack_public_path__ + "img/qq.0de761a7.svg";